<template>
<div class='vx-col w-full mt-4'>
    <div class="opciones">
        <h5 class="m-2 text-center">Agrega preguntas y respuestas
            <small><i>(Ingrese al menos 3 opciones.)</i></small></h5>
        <vs-row class="opciones">
            <vs-col vs-xs="12" vs-w="5" class="p-3">
                <p>Pregunta</p>
                <vs-input ref="pregunta"  class="w-full" maxlength="300" size="default" placeholder="Ingrese la pregunta" v-model="datos.pregunta" />
            </vs-col>
            <vs-col vs-xs="12" vs-w="5" class="p-3">
                <p>Respuesta</p>
                <vs-input class="w-full" maxlength="300" size="default" placeholder="Ingrese la respuesta" v-model="datos.respuesta" @keyup.enter="f_guardar()" />
            </vs-col>
            <vs-col vs-xs="12" vs-w="2" class="p-3 mt-4">
                <vs-button class="w-full" :color="propiedades.btn_color" @click="f_guardar()"> {{ propiedades.btn_texto }} </vs-button>
            </vs-col>
        </vs-row>
        <vs-divider />
        <vs-table max-items="20" stripe search pagination :data="arregloOpciones" no-data-text="Sin opciones disponibles">
            <template slot="header">
                <vs-chip color="primary">Cantidad: &nbsp;&nbsp;&nbsp; <b> {{ arregloOpciones.length }}</b></vs-chip>
            </template>
            <template slot="thead">
                <vs-th width="35%">Pregunta</vs-th>
                <vs-th>Respuesta</vs-th>
                <vs-th>Acciones</vs-th>
            </template>
            <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>
                        <p> {{tr.pregunta}}</p>
                    </vs-td>
                    <vs-td>
                        <p> {{tr.respuesta}}</p>
                    </vs-td>
                    <vs-td>
                        <vs-button icon="edit" color="warning" @click="f_editar(tr);"></vs-button>
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>
    </div>
</div>
</template>

<script>
import GeneralMixin from '@/mixins/GeneralMixin';
export default {
    mixins: [GeneralMixin],
    props: {
        datos_editar: {
            type: Object,
            default: function () {
                return {};
            },
        }
    },
    components: {},
    data() {
        return {
            datos:{
                id:0
            },
            arregloOpciones:[],
            propiedades: {
                btn_color: "primary",
                btn_texto: "Agregar"
            },
            id_juego:0,
        };
    },
    created() {},
    mounted() {
        let me = this;
        me.f_iniciar();
    },
    methods: {
        f_iniciar() {
            let me = this;
            me.id_juego = me.datos_editar.id;
            // console.log('datos editar', me.datos_editar, me.id_juego)
            me.propiedades = {
                btn_color: "primary",
                btn_texto: "Agregar"
            }
            me.f_get_opciones_juego();
        },
        f_get_opciones_juego() {
            let me = this;
            me.$vs.loading();
            me.$http.get(this.$server_url + 'get_opciones_emparejar/' + me.id_juego)
                .then(function (response) {
                    // console.log(response.data);
                    me.arregloOpciones = response.data;
                    me.$vs.loading.close();
                })
                .catch(function () {
                    me.f_notificaciones("No se logró obtener las respuestas del juego")
                    me.$vs.loading.close();
                });
        },
        f_guardar() {
            let me = this;
            if (me.datos.pregunta == '' || me.datos.pregunta == null) {
                me.f_notificaciones("Ingresa la pregunta", "danger")
                return
            }
            if (me.datos.respuesta == '' || me.datos.respuesta == null) {
                me.f_notificaciones("Ingresa la respuesta", "danger")
                return
            }
            let datos_guardar_opciones = new FormData();
            datos_guardar_opciones.append('id', me.datos.id);
            datos_guardar_opciones.append('id_juego', me.id_juego);
            datos_guardar_opciones.append('pregunta', me.datos.pregunta);
            datos_guardar_opciones.append('respuesta', me.datos.respuesta);
            console.log(me.datos.id > 0, me.datos.id,datos_guardar_opciones, me.datos, me.id_juego)
            me.$vs.loading();
            me.$http.post(this.$server_url + 'save_opciones_emparejar', datos_guardar_opciones)
                .then(function (response) {
                    console.log('response', response, response.data);
                    me.datos = {};
                    me.propiedades = {
                        btn_color: "primary",
                        btn_texto: "Agregar"
                    }
                    // me.datos.pregunta.focus();
                    me.f_get_opciones_juego();
                    me.f_notificaciones("Opción agregada con éxito")
                    me.$vs.loading.close();
                })
                .catch(function () {
                    me.f_notificaciones("Error al agregar la opción de respuesta")
                    me.$vs.loading.close();
                });
        },
        f_editar(item) {
            let me = this;
            me.datos = item
            // console.log(me.datos)
            me.propiedades = {
                btn_color: "warning",
                btn_texto: "Editar"
            }
        }
    }
};
</script>
